import { Splide, SplideSlide } from "@splidejs/react-splide";
const Products = (props) => {
  const { name, description, products } = props;
  return (
    <div className="space-y-5 md:space-y-10" key={name}>
      <div>
        <p className="text-center  text-2xl md:text-3xl">{name}</p>
        <p>{description}</p>
      </div>
      <div>
        <Splide
          options={{
            type: "loop", // Enables infinite looping
            perPage: 4, // Number of items per slide
            rewind: true, // Allows rotation
            loop: true,
            gap: "1rem", // Space between slides
            speed: 140000,
            interval: 10,
            autoplay: true,
            arrows: false,
            pauseOnHover: true,

            breakpoints: {
              992: {
                perPage: 3, // 3 items per page for screens < 992px
              },
              768: {
                perPage: 2, // 2 items per page for screens < 768px
              },
              480: {
                perPage: 1, // 1 item per page for screens < 480px
              },
            },
          }}
        >
          {products.map((product, i) => {
            return (
              <SplideSlide>
                <div
                  key={i}
                  className="space-y-3 md:space-y-5 hover:opacity-90"
                >
                  <div className="aspect-square rounded-3xl overflow-hidden">
                    <img
                      src={product.img}
                      className="w-full h-full object-cover"
                      alt={product?.description}
                    />
                  </div>
                  <div className="space-y-4">
                    <p className="text-center font-semibold">
                      {product.description}
                    </p>
                    <p className="text-right bg-white w-max ml-auto mr-auto pt-1.5 pb-1 px-4 text-gray-600 rounded">
                      {product.price} MMK
                    </p>
                  </div>
                  <div className="flex items-center justify-center">
                    <a href={product.link}>
                      <button className="bg-black text-white px-10 py-2 rounded-full cursor-pointer">
                        Buy
                      </button>
                    </a>
                  </div>
                </div>
              </SplideSlide>
            );
          })}
        </Splide>
      </div>
    </div>
  );
};

export default Products;
